const theme = {
	'primary-color': '#287ED8',
	'primary-1': '#E7F7FF',
	'a-color': '#fff'
}

module.exports = {
	theme
}
